export default __webpack_public_path__ + "static/media/loading_logo.b373a6f3.jpg";